import React, { useState, useEffect } from 'react';
import { Table, Pagination } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import Loader from 'components/loaders/Loader';
import { format, parseISO } from 'date-fns';
import { useBookingHistoryContext } from '../BookingHistory/BookingHistoryContext';
import styles from './styles.module.scss';

const PAGE_SIZE = 10;

export const BookingHistoryDetails = () => {
  const intl = useIntl();
  const { bookingHistory, isFetching } = useBookingHistoryContext();
  const [activePage, setActivePage] = useState(1);

  useEffect(() => {
    setActivePage(1);
  }, [bookingHistory]);

  if (isFetching) return <Loader />;

  const totalPages = Math.ceil(bookingHistory.length / PAGE_SIZE);
  const paginatedRows = bookingHistory.slice(
    (activePage - 1) * PAGE_SIZE,
    activePage * PAGE_SIZE,
  );

  return (
    <div className={styles.tableWrap}>
      <Table
        celled
        striped
        unstackable
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <FormattedMessage id="userEmail" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id="userName" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id="address" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id="apartmentNumber" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id="resourceType" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id="startDate" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id="endDate" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id="createdAt" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id="cancelled" />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {paginatedRows.length > 0 ? paginatedRows.map((row, index) => {
            const createdAt = row.createdAt
              ? parseISO(row.createdAt) : '-';
            const formattedCreatedAt = format(createdAt, 'yyyy-MM-dd');

            const formattedCancelled = row.canceled
              ? intl.formatMessage({ id: 'yes' })
              : intl.formatMessage({ id: 'no' });
            return (
              <Table.Row key={row.id || `${row.userEmail}-${index}`}>
                <Table.Cell>{row.userEmail || '-'}</Table.Cell>
                <Table.Cell>{row.userName || '-'}</Table.Cell>
                <Table.Cell>{row.address || '-'}</Table.Cell>
                <Table.Cell>{row.apartmentNumber || '-'}</Table.Cell>
                <Table.Cell>{row.resourceType || '-'}</Table.Cell>
                <Table.Cell>{row.startDate || '-'}</Table.Cell>
                <Table.Cell>{row.endDate || '-'}</Table.Cell>
                <Table.Cell>{formattedCreatedAt}</Table.Cell>
                <Table.Cell>{formattedCancelled}</Table.Cell>
              </Table.Row>
            );
          }) : (
            <Table.Row>
              <Table.Cell colSpan={8}>
                <div className={styles.emptyState}>
                  {intl.formatMessage({ id: 'noBookingHistory' })}
                </div>
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>

        {totalPages > 1 && (
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell
                colSpan={8}
                className={styles.pagination}
              >
                <Pagination
                  activePage={activePage}
                  totalPages={totalPages}
                  onPageChange={(_, { activePage: page }) => setActivePage(page)}
                  boundaryRange={0}
                  siblingRange={1}
                  ellipsisItem={null}
                  firstItem={null}
                  lastItem={null}
                />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        )}
      </Table>
    </div>
  );
};
